module.exports = __webpack_public_path__ + "root-c2082cbd/4451635483e43df56dfdb15abe9a096f.svg";